import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { livenessModule } from './modules/liveness';
import { authModule } from './modules/auth';

export default createApp({
  features: [catalogPlugin, navModule, homeModule, livenessModule, authModule],
});
